import { LitElement, html, unsafeCSS, CSSResultGroup } from "lit";
import { customElement, property } from "lit/decorators.js";
import informationBlockStyles from "../../styles/information-block.css?inline";
import { Icon } from "../Icon";

// Import nécessaire pour enregistrer le composant Icon
Icon;

interface InformationItem {
  icon: string;
  title: string;
  content: string;
}

@customElement("apidae-detail-view-information-block-listing-w-columns")
export class InformationBlockListingWColumns extends LitElement {
  static styles: CSSResultGroup = unsafeCSS(informationBlockStyles);

  @property({ type: Array })
  items: InformationItem[] = [];

  /** Nombre de colonnes (1, 2 ou 3). Par défaut 3. */
  @property({ type: Number })
  columns: 1 | 2 | 3 = 3;

  render() {
    if (!this.items || this.items.length === 0) {
      return html``;
    }

    const colsClass = `information-block-listing-w-columns-container--cols-${this.columns}`;
    return html`
      <div class="information-block-listing-w-columns-container ${colsClass}">
        ${this.items.map(
          (item) => html`
            <div
              class="information-block-listing information-block-listing-column"
            >
              <div
                class="information-block-listing-header"
                style="display: flex; align-items: center; gap: 8px;"
              >
                ${item.icon
                  ? html`
                      <apidae-icon
                        name="${item.icon}"
                        size="20"
                        color="currentColor"
                      ></apidae-icon>
                    `
                  : ""}
                <span>${item.title}</span>
              </div>
              <div class="information-block-listing-content">
                <span>${item.content}</span>
              </div>
            </div>
          `,
        )}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "apidae-detail-view-information-block-listing-w-columns": InformationBlockListingWColumns;
  }
}
